define('viewmodels/configuration/RiskAreas',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger'], function (ko, router, appsecurity, navigation, app,system,logger) {
    var title = 'RiskAreas';

    var RaViewModel = {
        activate: activate,
        title: title,
        attached: attached,
        
        logger: logger,
        appsecurity:appsecurity,
        RiskAreasList: ko.observableArray(),
        editableRiskArea: ko.observable(),
        popUpTitle: ko.observable(),
        popUpNotesTitle: ko.observable(),
        finalSaveTest: ko.observable(),
        
        availableFactors: ko.observableArray(),
        selectedFactors: ko.observableArray(),
        test: ko.observableArray(),
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        newObservableName: ko.observable("TESTVAL"),
       detached:detached,
        showNotes:showNotes,
        addFunctionality: addFunctionality,
        editFunctionality: editFunctionality,
        deleteFunctionality: deleteFunctionality,
        savePopUpButton: savePopUpButton,
        cancelPopUpButton: cancelPopUpButton,
        dtobservable: ko.computed(function () {
            return appsecurity.finalConfigurationSave();
        }).extend({ notify: 'always' }),
        configuartionSaveState: ko.observable(false)
    };

    return RaViewModel;

    var isEdit, RaTableObj = false;
    var GetAllRiskAreaAjax = {};
    var AddRiskAreaAjax = {};
    var GetAllUnmapedFactorsAjax = {};
    var GetMappedFactorsAjax = {};
    
    function test(newValue) {
        if (newValue == false && RaTableObj != undefined) {

            RaViewModel.configuartionSaveState(true);
            RaTableObj.draw(false);

        }
    }
    function tableCallBack(val) {
        
        if (RaViewModel.configuartionSaveState()) {
            for (i = 1, j = ($('#RiskAreaTable').find('tr').length) ; i < j; i++) {
                var editControl = $($($('#RiskAreaTable').find('tr').get(i)).find('td').get(2)).find('a').get(1);
                var deleteControl = $($($('#RiskAreaTable').find('tr').get(i)).find('td').get(2)).find('a').get(2);
                ko.cleanNode(editControl);
                ko.cleanNode(deleteControl);
                ko.applyBindingsToNode(editControl, { click: RaViewModel.editFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, RaViewModel);
                ko.applyBindingsToNode(deleteControl, { click: RaViewModel.deleteFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, RaViewModel);
            }
        }
        else
            ko.applyBindingsToNode($('#RiskAreaTable'));

    }
    function activate() {
        RaViewModel.dtobservable.subscribe(test);
    };
    function detached() {
        $($(document.getElementsByClassName('list-group-item')).get(3)).removeClass('active')

    }; 
    function attached() {
        $($(document.getElementsByClassName('list-group-item')).get(3)).addClass('active');
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');

        try {
            RaViewModel.finalSaveTest(RaViewModel.appsecurity.finalConfigurationSave());
            GetAllRiskAreaAjax = {
                url: "/api/Configuration/GetAllRiskAreas",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };

            GetAllRiskAreas(GetAllRiskAreaAjax);

            
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskAreas(GetAllRiskAreaAjax) {
       
        try{
            $.ajax(GetAllRiskAreaAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in RiskAreas.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            
            try{
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {
                        var mappedRiskAreas = $.map(jsonResult, function (result) {
                            return new RiskAreaModel(result);
                        })

                        RaViewModel.RiskAreasList(mappedRiskAreas);
                        RaTableObj = $('#RiskAreaTable').DataTable({
                            "bResponsive": true,
                           
                            "aoColumnDefs": [ {
                                "aTargets": [0],
                                "bVisible": false
                            }, {
                                "aTargets": [2],
                            "bSortable": true
                            }, {
                                "aTargets": [3],
                                "bSortable": false,
                            "sClass": "text-center"
                            
                            }
                            ], fnDrawCallback: tableCallBack
                            
                        });
                    }
                    else {

                    }
                }
                else {
                    logger.logWarning('You have been logged out. Please login again to complete the operation.', 'Warning', system.getModuleId(RaViewModel), true);
                    
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        
                    })
                }
                else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreas.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        };


    };

    function addRiskArea(data) {
       
        try{
            AddRiskAreaAjax = {
                url: "/api/Configuration/AddRiskArea",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: {RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: data.RiskAreaType(), RiskAreaNotes: data.RiskAreaNotes()}
            };


            $.ajax(AddRiskAreaAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskArea() method in RiskAreas.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            
            try{
                if (jsonResult != null) {
                    if (jsonResult.RiskAreaId != 0 && jsonResult.RiskAreaName != null && jsonResult.RiskAreaType != null) {
                        var newRiskArea = new RiskAreaModel(jsonResult);
                        RaViewModel.RiskAreasList.push(newRiskArea);
                        var node = RaTableObj.row.add([newRiskArea.RiskAreaId(), newRiskArea.RiskAreaName(), newRiskArea.RiskAreaType(), '<a href="javascript:void(0)" title="Risk Area Notes" class="btn-borderless widget-button" data-bind="click: $root.showNotes"><i class="fa fa-credit-card"></i></a><a href="javascript:void(0)" title="Edit Risk Area" class="btn-borderless widget-button" data-bind="click: $root.editFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="fa fa-edit text-success icons-align"></i></a><a href="javascript:void(0)" title="Delete Risk Area" class="btn-borderless widget-button" data-bind="click: $root.deleteFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                        RaTableObj.page('last').draw(false);
                        var addedRow = $('#RiskAreaTable').find('tr').get(1);
                        ko.applyBindingsToNode(node);
                       
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RaViewModel.showNotes }, newRiskArea);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RaViewModel.editFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, newRiskArea);
                        ko.applyBindingsToNode($(node.node()).find('a').get(2), { click: RaViewModel.deleteFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, newRiskArea);
                        
                       
                        logger.logSuccess('Risk Area added successfully.','Success',system.getModuleId(RaViewModel),true);
                       
                    }
                    else {
                        logger.logError('Failed to add Risk Area.', 'Error', system.getModuleId(RaViewModel), true);
                    }
                }
                else {
                    logger.logError('Some error in the application. Please contact maintenance team.', 'Error', system.getModuleId(RaViewModel), true);
                    
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        
                    })
                }
                else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in addRiskArea() method in RiskAreas.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        };
    }


    function updateRiskArea(data) {
        try{
            $.ajax({
                url: "/api/Configuration/UpdateRiskArea",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: { RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: data.RiskAreaType(), RiskAreaNotes: data.RiskAreaNotes() }
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateRiskArea() method in RiskAreas.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            
            try{
                if (result == 1) {
                    var rowIndex = data.TargetRow();
                    RaViewModel.RiskAreasList()[rowIndex].RiskAreaId(data.RiskAreaId());
                    RaViewModel.RiskAreasList()[rowIndex].RiskAreaName(data.RiskAreaName());
                    RaViewModel.RiskAreasList()[rowIndex].RiskAreaType(data.RiskAreaType());
                    RaViewModel.RiskAreasList()[rowIndex].RiskAreaNotes(data.RiskAreaNotes());
                    var node = RaTableObj.row(rowIndex).data([data.RiskAreaId(), data.RiskAreaName(), data.RiskAreaType(), '<a href="javascript:void(0)" title="Risk Area Notes" class="btn-borderless widget-button" data-bind="click: $root.showNotes"><i class="fa fa-credit-card"></i></a><a href="javascript:void(0)" title="Edit Risk Area" class="btn-borderless widget-button" data-bind="click: $root.editFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="fa fa-edit text-success icons-align"></i></a><a href="javascript:void(0)" title="Delete Risk Area" class="btn-borderless widget-button" data-bind="click: $root.deleteFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                    
                    ko.applyBindingsToNode(node);
                ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RaViewModel.showNotes },data);
                    ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RaViewModel.editFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, data);
                    ko.applyBindingsToNode($(node.node()).find('a').get(2), { click: RaViewModel.deleteFunctionality, css: { 'disabled': (!RaViewModel.appsecurity.finalConfigurationSave()) } }, data);
                    
                   
                    logger.logSuccess('Risk Area updated successfully.','Success',system.getModuleId(RaViewModel),true);
                }
                else if (result == 0) {
                    logger.logWarning('No such Risk Area exists. Please refresh the page again and perform the edit operation.', 'Warning', system.getModuleId(RaViewModel), true);
                    
                }
                else {
                    logger.logError('Some error occured. Please refresh the page again and perform the edit operation', 'Error', system.getModuleId(RaViewModel), true);
                    
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        }


        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in updateRiskArea() method in RiskAreas.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        }
    }


    function deleteRiskArea(data, event) {
        
        try{
            $.ajax({
                url: "/api/Configuration/DeleteRiskArea?RiskAreaID=" + data.RiskAreaId(),
                type: "DELETE",
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteRiskArea() method in RiskAreas.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            
            try{
                if (result == 1) {
                    var targetRow = $(event.currentTarget).closest("tr").get(0);
                    data.TargetRow(targetRow._DT_RowIndex);
                    RaTableObj.row(targetRow).remove().draw(false);
                    
                    RaViewModel.RiskAreasList.splice(data.TargetRow(), 1);
                    logger.logSuccess('Risk Area deleted successfully.','Success',system.getModuleId(RaViewModel),true);
                }
                else if (result == 0) {
                    logger.logWarning('No such Risk Area exists. Please refresh the page again and perform the delete operation.', 'Warning', system.getModuleId(RaViewModel), true);
                    
                }
                else {
                    logger.logError('Some error occured. Please refresh the page again and perform the delete operation.', 'Error', system.getModuleId(RaViewModel), true);
                    
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
           
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteRiskArea() method in RiskAreas.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteRiskArea() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        }
    }


    function addFunctionality() {
       
        try{
            var newRiskArea = new RiskAreaModel({ RiskAreaId: 999, RiskAreaName: "", RiskAreaType: "Value", RiskAreaNotes: ""});
            RaViewModel.editableRiskArea(newRiskArea);
            RaViewModel.popUpTitle("Add Risk Area Details");
        RaViewModel.addPopUpCss(true);
        RaViewModel.editPopUpCss(false);
        $('#frmRiskArea').modal('show');
        $('#EditRaTextArea').attr('placeholder', 'Risk Area Notes');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            isEdit = false;
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: addFunctionality() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    }

    function editFunctionality(data, event) {
       
        try {
            if (!RaViewModel.configuartionSaveState()) {
                if (data.RiskAreaNotes() == "" || data.RiskAreaNotes() == "There are no notes available for this Risk Area") {
                    data.RiskAreaNotes("");
                }
                var selectedRow = $(event.currentTarget).closest("tr").get(0);
                data.TargetRow(selectedRow._DT_RowIndex);
                var newObservable = new RiskAreaModel({ RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: data.RiskAreaType(), RiskAreaNotes: data.RiskAreaNotes() });
                newObservable.TargetRow(selectedRow._DT_RowIndex);
                RaViewModel.editableRiskArea(newObservable);
                RaViewModel.popUpTitle("Edit Risk Area Details");
                RaViewModel.addPopUpCss(false);
                RaViewModel.editPopUpCss(true);
                $('#frmRiskArea').modal('show');
                if (data.RiskAreaNotes() == "" || data.RiskAreaNotes() == "There are no notes available for this Risk Area") {

                    $('#EditRaTextArea').attr('placeholder', 'Risk Area Notes');
                }
                $('#modalContent').css({
                    'margin-top': '25%'

                });
                isEdit = true;
            }
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    };

    function deleteFunctionality(data, event) {
        
        try {
            if (!RaViewModel.configuartionSaveState()) {
                app.showMessage('Are you sure you want to delete this Risk Area?', 'Delete Risk Area', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteRiskArea(data, event);
                        }
                    });
            }
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: deleteFunctionality() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    };

    function showNotes(data,event)
    {
         
        try {
            if (data.RiskAreaNotes() == "")
                data.RiskAreaNotes("There are no notes available for this Risk Area");
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            var newObservable = new RiskAreaModel({ RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: data.RiskAreaType(), RiskAreaNotes: data.RiskAreaNotes() });
            newObservable.TargetRow(selectedRow._DT_RowIndex);
            RaViewModel.editableRiskArea(newObservable);
            RaViewModel.popUpNotesTitle("Risk Area Notes");
            $('#frmRiskAreaNotes').modal('show');
            $('#modalContentNotes').css({
                'margin-top': '25%'

            });
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: showNotes() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    }

    
    function savePopUpButton(data) {
        try{
            $('#valError').hide();
            var duplicateCheck = 0;
            
            for (var i = 0, j = RaViewModel.RiskAreasList().length; i < j; i++) {
                if ((data.RiskAreaName().toUpperCase() == RaViewModel.RiskAreasList()[i].RiskAreaName().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheck++;
            }

            if (data.RiskAreaName() == "") {
                $('#valError').show();
                $('#valError').text('Risk Area name is required.');
            }
            else {
                if (!isEdit) {
                    if (duplicateCheck == 1) {
                        
                        $('#valError').show();
                        $('#valError').text(data.RiskAreaName() + ' already exists. Please enter a different Risk Area.');
                    }
                    else {
                        addRiskArea(data);
                        $('#frmRiskArea').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
            }
            else if (data.RiskAreaName().length >100)
            {
                
                 $('#valError').show();
        $('#valError').text('Risk Area name cannot exceed 100 characters.');
            }
            else if (data.RiskAreaNotes().length > 5000)
            {
                $('#valError').show();
                $('#valError').text('Risk Area notes cannot exceed 5000 characters.');
                }
                else {
                    if (duplicateCheck == 1) {
                       
                        $('#valError').show();
                        $('#valError').text(data.RiskAreaName() + ' already exists. Please enter a different Risk Area.');
                    }
                    else {
                        
                        updateRiskArea(data);
                        $('#frmRiskArea').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }

        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: savePopUpButton() method in RiskAreas.js';
            logger.logMessage(msg);
        }
        
    };

    function cancelPopUpButton(data) {
        try{
            $('#frmRiskArea').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: cancelPopUpButton() method in RiskAreas.js';
            logger.logMessage(msg);
        }
    };

    function RiskAreaModel(item) {
        var self = this;
        self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
        self.RiskAreaId = ko.observable(item.RiskAreaId);
        self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
        self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
        self.TargetRow = ko.observable();
        
    };

});

